import {useEffect, useState} from 'react';
import {Account} from '../../accounts/types';
import {checkAccountSession} from '../services/AccountSessionService';
import {AccountSessionInfo} from '../types';

let checkQueue: Promise<void> = Promise.resolve();

export const useAccountSession = (account: Account) => {
    const [info, setInfo] = useState<AccountSessionInfo>({
        accountId: account.id,
        email: account.emailAddress,
        isActive: false,
        isExpired: true
    });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkSession = async () => {
            setIsLoading(true);
            
            checkQueue = checkQueue.then(async () => {
                const result = await checkAccountSession(account);
                setInfo(result);
                setIsLoading(false);
            });
            
            await checkQueue;
        };

        checkSession();
    }, [account, account.updatedAt]);

    return {
        status: {isActive: info.isActive, isExpired: info.isExpired},
        isLoading
    };
};
